import script from "./report-4.vue?vue&type=script&setup=true&lang=js"
export * from "./report-4.vue?vue&type=script&setup=true&lang=js"

import "./report-4.vue?vue&type=style&index=0&id=1fec5c67&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fec5c67"]])

export default __exports__